import React from "react";
import StudentNavbar from "../components/student/StudentNavbar";

const StudentLayout = ({ children }) => {
  return (
    <div className="min-h-screen bg-[#F5F5F5]">
      <StudentNavbar />

      <section className="mt-0.5 w-full bg-[#880A73] h-[322px]" />

      <main className="-mt-64 xl:-mt-60 px-6 pb-10 font-['Inter']">
        <div className="max-w-[1748px] mx-auto bg-white min-h-[calc(100vh-322px)] shadow-[0_0_3.7px_4px_#00000040]">
          <div>{children}</div>
        </div>
      </main>
    </div>
  );
};

export default StudentLayout;
